import React from "react";
import { useHistory } from "react-router-dom";
import styles from "lib/components/Timeline/TimelineItem/TimelineItem.module.scss";
import Tooltip from "lib/components/Tooltip/TooltipWrapper";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Typography } from "@mui/material";
import dayjs from "dayjs";

export const TimelineItemMinimal = ({ event }) => {
  const navigate = useHistory();

  // Destructurare curată a proprietăților eventului
  const {
    id,
    title,
    date: dateTime,
    startTime: time,
    location,
    description,
    county,
    participants = [],
    custom = false,
    tickets = [],
  } = event;

  // Funcții helper pentru logică separată
  const formatTime = (date) => {
    if (!date) return "";
    const newDate = new Date(date);
    const options = { hour12: false, timeZone: "Europe/Bucharest" };
    return newDate.toLocaleTimeString("en-RO", options);
  };

  const getParticipantsCount = () => {
    return custom
      ? tickets.filter((ticket) => ticket.valid === true).length
      : participants.length;
  };

  // Event handlers
  const handleEventClick = () => {
    navigate.push(`/volunteer-tickets/${id}`);
  };

  const customEventStyle = "rgb(255 182 1 / 35%) 0px 5px 15px";

  return (
    <div
      className={styles.mainContainer}
      onClick={handleEventClick}
      style={{
        cursor: "pointer",
        boxShadow: custom && customEventStyle,
      }}
    >
      <div className={styles.contentContainer}>
        <div className={styles.dateTimeContainer}>
          <Typography variant="tableContent">
            {dayjs(dateTime).format("DD/MM/YYYY")} {formatTime(time)}
          </Typography>

          <div className={styles.buttonsContainer}>
            <Tooltip
              position="right"
              textTip="Deschide în tab nou"
              followCursor
            >
              <div className={styles.openEvent} onClick={handleEventClick}>
                <OpenInNewIcon fontSize="small" />
              </div>
            </Tooltip>
          </div>
        </div>

        <div className={styles.locationContainer}>
          <Typography variant="tableContent">
            {county?.name && `${county.name} - `}
            {location}
          </Typography>
        </div>

        <h2>{title}</h2>

        <p className={styles.numberOfParticipantsStyle}>
          Participanti: {getParticipantsCount()}
        </p>

        <div
          className={styles.descriptionContainer}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
};
